import * as t from "io-ts";

export const SiteStateAnonymousV = t.type({
  type: t.literal('anonymous'),
  credits: t.number,
  expiration: t.union([t.number, t.null])
});

export const SiteStateClaimedV = t.type({
  type: t.literal('claimed'),
  site_id: t.number,
  expiration: t.union([t.number, t.null]),
  user_data: t.type({
    email: t.string,
    credits: t.number,
    plan_slug: t.string
  })
});

export const SiteStateErrorV = t.type({
  error: t.string
});

export const SiteStateV = t.union([
  SiteStateAnonymousV,
  SiteStateClaimedV,
  SiteStateErrorV
]);

export type SiteState = t.TypeOf<typeof SiteStateV>;

export const FutureLayerSettingsV = t.union([t.type({
  homepageId: t.number,
  isClaimed: t.boolean,
  claimUrl: t.string,
  siteState: t.union([SiteStateV, t.null])
}), t.literal(false)]);

export type FutureLayerSettings = t.TypeOf<typeof FutureLayerSettingsV>;